module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "misionpage"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row main-content"
  }, [_c('div', {
    staticClass: "col-md-6",
    attrs: {
      "data-aos": "fade-up"
    }
  }, [_c('div', {
    staticClass: "medium-title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.state.misionTitle))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.state.misionText))])]), _vm._v(" "), _c('div', {
    staticClass: "medium-title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.state.visionTitle))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.state.visionText))])])]), _vm._v(" "), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 img-contnt",
    attrs: {
      "data-aos": "fade-left"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./../../assets/imgs/nosotros_foto2.png"),
      "width": "90%"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07542864"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nosotros/MisionPage.vue
// module id = 142
// module chunks = 0